import Axios from 'axios';
import { GenericError, ServerError } from 'common/helpers';
import { cancelPricingRequest } from 'store/api/cartApi';

export interface CartContactModel {
	goodsReceptionContactName: string;
	goodsReceptionPhoneNumber: string;
	customerRequisition: string;
	projectName: string;
	projectNumber: string;
	comment: string;
}

export interface ProshopDraftModel {
	orderId: number;
	openAsCartUrl: string;
	orgName: string;
	modified: string;
	user: string;
}

export const getCartContact = async (
	url: string
): Promise<CartContactModel | null> => {
	try {
		cancelPricingRequest();
		const result = await Axios({
			method: 'get',
			url,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'content-type': 'application/json; charset=utf-8',
			},
		});
		return result.data || null;
	} catch (err) {
		console.error(err);
		return null;
	}
};

export const getProshopDrafts = async (
	url: string
): Promise<ProshopDraftModel[] | null> => {
	try {
		cancelPricingRequest();
		const result = await Axios({
			method: 'get',
			url,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'content-type': 'application/json; charset=utf-8',
			},
		});
		return result.data || null;
	} catch (err) {
		console.error(err);
		return null;
	}
};

export const updateCartContact = async (
	url: string,
	payload: CartContactModel
): Promise<any> => {
	try {
		cancelPricingRequest();
		const result = await Axios({
			method: 'patch',
			url,
			data: payload,
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'content-type': 'application/json; charset=utf-8',
			},
		});
		return result.data || null;
	} catch (err: any) {
		const statusCode = err.response?.status;
		const errorCode = err.response?.data?.errorCode;
		const message = err.response?.data?.message;

		if (statusCode === 400) {
			throw { errorCode, message } as GenericError;
		} else {
			throw new ServerError();
		}
	}
};
